import template from './newsItem.html';
import controller from './newsItem.controller';
import './newsItem.scss';

let newsItemComponent = {
  restrict: 'E',
  bindings: {news: '<', newsId: '<'},
  template,
  controller
};

export default newsItemComponent;



// WEBPACK FOOTER //
// ./client/app/components/apps/newsItem/newsItem.component.js